import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/icon/danger-red.png'


const _hoisted_1 = { class: "bg-white p-4 relative mt-4 rounded-md shadow border-2 border-red-500" }
const _hoisted_2 = { class: " flex items-end justify-between" }
const _hoisted_3 = { class: " flex items-center justify-between" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  alt: "warning manifest",
  src: _imports_0,
  class: "lg:w-12 sm:w-9 md:mx-2"
}, null, -1)
const _hoisted_5 = { class: "-my-4 ml-4 flex flex-col items-start justify-between" }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: " font-bold color-primary  lg:text-base md:text-base text-sm color-black mb-1" }, "Paket Belum Dikirimkan", -1)
const _hoisted_7 = { class: " break-all" }
const _hoisted_8 = { class: "text-lg font-bold" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode()
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "text-sm" }, "Resi", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_12 = { class: "text-lg font-bold" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode()
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "text-sm" }, "Barang", -1)
const _hoisted_15 = { class: "detail-card-accumulate mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("p", _hoisted_7, [
            _createVNode("span", _hoisted_8, _toDisplayString(_ctx.countPendingDelivery.waybillsCount), 1),
            _hoisted_9,
            _hoisted_10,
            _hoisted_11,
            _createVNode("span", _hoisted_12, _toDisplayString(_ctx.countPendingDelivery.goodsCount), 1),
            _hoisted_13,
            _hoisted_14
          ])
        ])
      ]),
      _createVNode("div", _hoisted_15, [
        _createVNode("button", {
          class: "font-bold color-primary mb-1",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goto('deliveryItem')))
        }, "Lihat Semua")
      ])
    ])
  ]))
}